import React from 'react'
import CInput from 'lemon-campaign-ui/lib/molecules/Input'
import get from 'lodash/get'

const defaultResponsiveOptions = {}
const Input = ({ component, inputMap, handlers, defaults }) => {
  const draft = get(component, 'content.misc.wysiwyg')

  return (
    <CInput
      {...defaults}
      isResponsive={get(component, 'content.responsive.active', true)}
      hasResponsiveContainer={get(component, 'content.responsive.hasContainer', true)}
      responsiveOptions={get(component, 'content.responsive.options', defaultResponsiveOptions)}
      inputType={component.content.inputType}
      emoji={component.content.showIcon && component.content.icon}
      placeholder={component.content.placeholder}
      required={component.content.required}
      fieldName={inputMap.byComponent[component._id].name}
      autocomplete={inputMap.byComponent[component._id].autocomplete}
      onFocus={handlers.handleKeyboardOpened}
      onBlur={handlers.handleKeyboardClosed}
      draft={draft}
    />
  )
}

export default Input
